import type { TFunction } from 'i18next';

/** Kurs umumiy davomiyligi: "27 daq", "1 soat 15 daq" (joriy tilda). */
export function formatTotalDuration(totalSec: number, t: TFunction): string {
  const min = Math.max(1, Math.round(totalSec / 60));
  if (min < 60) return t('courses.durationMin', { m: min });
  const h = Math.floor(min / 60);
  const m = min % 60;
  return m ? t('courses.durationHours', { h, m }) : t('courses.durationHoursOnly', { h });
}

/** Dars davomiyligi: 420 → "7:00", 3725 → "1:02:05" */
export function formatClock(totalSec: number): string {
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  const mm = h ? String(m).padStart(2, '0') : String(m);
  return `${h ? `${h}:` : ''}${mm}:${String(s).padStart(2, '0')}`;
}
